import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { useBooth } from '../../../../../hooks/useBooth';
import { Booth } from '../../../../../interfaces/interfaces';
import { useSelector } from '../../../../../reduxToolkit/typedRedux';
import VyModal from '../../../../common/VyModal';
import BigBooth from './BigBooth/index';

export const OpenBooth = () => {
  const event = useSelector((state) => state.common.event);
  const booths = useSelector((state) => state.common.booths);
  const [currentBooth, setCurrentBooth] = useState<Booth>();
  const [, updateHeight] = useState(false);

  const router = useRouter();
  const { closeBooth } = useBooth();

  useEffect(() => {
    const openId = router.query.openId;

    if (openId && typeof openId === 'string' && (!currentBooth || currentBooth?._id !== openId)) {
      const booth = booths?.find((booth) => booth?._id === openId);
      if (booth) setCurrentBooth(booth);
    }

    if (!openId) setCurrentBooth(undefined);
  }, [router]);

  // Hacky way to refresh current booth when booths are updated
  useEffect(() => {
    if (!currentBooth) return;

    const booth = booths?.find((booth) => booth?._id === currentBooth._id);

    if (booth) setCurrentBooth(booth);
  }, [booths]);

  if (!event) return null;

  return (
    <VyModal maxWidth="90vw" open={!!currentBooth} onClose={closeBooth} hasDefaultPadding={false} disableEnforceFocus>
      {() => (
        <div className="w-[1000px] max-w-full">
          <BigBooth booth={currentBooth!} updateHeight={() => updateHeight((prev) => !prev)} isModal />
        </div>
      )}
    </VyModal>
  );
};
